'use client';

import { Input as BaseInput } from '@base-ui/react/input';
import * as stylex from '@stylexjs/stylex';
import { inputMarker } from '../../markers.stylex';
import { typography } from '../../../../styles/typography';
import { formStyles } from '../../form.styles';
import { FieldControlContext } from './Field';
import { use } from 'react';
export function RawInput({
  styles,
  ...props
}: BaseInput.Props & {
  styles?: stylex.StyleXStyles;
}) {
  return <BaseInput {...props} {...stylex.props(inputMarker, typography.body, formStyles.input, styles)} />;
}
export function Textarea({
  styles,
  ...props
}: Omit<React.ComponentProps<'textarea'>, 'name'> & {
  linesHigh?: number;
  styles?: stylex.StyleXStyles;
}) {
  const fieldControl = use(FieldControlContext);
  return <BaseInput {...fieldControl} {...stylex.props(inputMarker, typography.body, formStyles.input, sx.textarea(props.linesHigh ?? 4), styles)} placeholder={props.placeholder} render={<textarea />} />;
}
const _temp = {
  kB7OPa: "x1afcbsf",
  k1xSpc: "x78zum5",
  k1K539: "xat24cr",
  keoZOQ: "xdj266r",
  kHenm0: "x288g5",
  kAzted: "x82snj4",
  "$$css": true
};
const sx = {
  textarea: (linesHigh: number) => [_temp, {
    "--x-minHeight": (val => typeof val === "number" ? val + "px" : val != null ? val : undefined)(`${linesHigh}lh`)
  }]
};